/* global axios */
import ApiClient from './ApiClient';

// Mesmo endpoint que recebe as conversões externas (site/WordPress). O form de
// conversão manual do painel usa a MESMA rota de propósito: o evento entra no
// motor normal (touchpoint, classificação, cascade, tela de conversões,
// segmentações) — só muda a procedência (platform: 'manual').
class ConversionEventsAPI extends ApiClient {
  constructor() {
    super('conversion_events', { accountScoped: true });
  }

  createManual(payload) {
    return axios.post(this.url, payload);
  }
}

export default new ConversionEventsAPI();
